export default class MultiAddInputComponent extends React.Component {
    static defaultProps = {
        addButtonLabel: 'Add'
    }

    constructor(props) {
        super(props);

        this.state = {
            inputs: [1]
        };
    }

    componentDidUpdate() {
        this.refs['input' + (this.state.inputs.length - 1)].focus();
    }

    render() {
        return (
            <div>
                <div>
                    {this.getInputNodes()}
                </div>
                <button className='_button-white' style={{ width: '100%', textAlign: 'left' }} onClick={this.handleAddClick.bind(this)}>
                    <span className='fa fa-plus' />
                    <span style={{ marginLeft: 10 }}>{this.props.addButtonLabel}</span>
                </button>
            </div>
        );
    }

    getInputNodes() {
        return _.map(this.state.inputs, (value, index) => {
            return (
                <div key={index}>
                    <input type={this.props.inputType} name={this.props.name} ref={'input' + index} />
                </div>
            );
        });
    }

    handleAddClick(event) {
        event.preventDefault();
        let newInputs = this.state.inputs;
        newInputs.push(1);
        this.setState({ inputs: newInputs });
    }
}
